var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Music(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f50057",
    d: "M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5 V37z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.775,14.821C19.321,14.926,19,15.33,19,15.796V29c0,0.552-0.448,1-1,1h-1c-2.209,0-4,1.343-4,3 s1.791,3,4,3s4-1.343,4-3V21.334c0-0.466,0.321-0.87,0.775-0.974l7.306-1.686C29.551,18.565,30,18.922,30,19.404V26 c0,0.552-0.448,1-1,1h-1c-2.209,0-4,1.343-4,3s1.791,3,4,3s4-1.343,4-3V13.257c0-0.643-0.598-1.119-1.225-0.974L19.775,14.821z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Music);
export default __webpack_public_path__ + "static/media/icons8-music.16aeb8983e86ff164b8de07ed8cc35f8.svg";
export { ForwardRef as ReactComponent };